import { CHAIN_IDS } from '../constants/chain';

export const SUSDE_ADDRESSES_BY_CHAIN_ID: Readonly<Partial<Record<number, string>>> = {
  [CHAIN_IDS.MAINNET]: '0x9d39a5de30e57443bff2a8307a4256c8797a3497',
  [CHAIN_IDS.ARBITRUM]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.AVALANCHE]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.BASE]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.BSC]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.LINEA]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.MANTLE]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.OPTIMISM]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.PLASMA]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.SCROLL]: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  [CHAIN_IDS.SOLANA]: 'Eh6XEPhSwoLv5wFApukmnaVSHQ6sAnoD9BmgmwQoN2sN',
};
